import { useMemo } from "react";
import { ModifyDetail } from "../../../../redux/apiSpecifications/apiSubjects";
import { useTranslation } from "react-i18next";

type SubjectCreatedAddressDescriptionDetails = {
  address_type: string;
  address: string;
};

interface ISubjectCreatedAddressDescriptionProps {
  modifyDetailsJson: ModifyDetail[];
}

const SubjectCreatedAddressDescription = ({
  modifyDetailsJson,
}: ISubjectCreatedAddressDescriptionProps) => {
  const { t } = useTranslation();

  const getAddressTypeLabel = (code: string): string => {
    const translations: Record<string, string> = {
      D: t("address-type-D"),
      R: t("address-type-R"), 
      S: t("address-type-S"),
      L: t("address-type-L"),
      O: t("address-type-O"),
      A: t("address-type-A"),
    };
  
    return translations[code] || code;
  };

  const subjectAddressDescriptionDetails: SubjectCreatedAddressDescriptionDetails =
  useMemo(() => {
    return {
      address_type: getAddressTypeLabel(
        modifyDetailsJson.find((_) => _.key === "address_type")?.value ?? ""
      ),
      address: modifyDetailsJson.find((_) => _.key === "address")?.value ?? "",
    };
  }, [modifyDetailsJson, t]);
  return (
    <>
      {t("HISTORY-TEMPLATES.policy-subject-created-address-description", {
        address_type: subjectAddressDescriptionDetails.address_type,
        address: subjectAddressDescriptionDetails.address,
      })}
    </>
  );
};
export default SubjectCreatedAddressDescription;
